import React, { useCallback, useEffect, useState, useRef } from "react";
import classnames from "classnames";
import PropTypes from "prop-types";
import "./multiRangeSlider.css";

const MultiRangeSlider = ({ min, max, onChange }) => {

  const [minVal, setMinVal] = useState(min);
  const [maxVal, setMaxVal] = useState(max);

  const minValRef = useRef(null);
  const maxValRef = useRef(null);
  const range = useRef(null);

  // Convert value to percentage
  const getPercent = useCallback(
    (value) => Math.round(((value - min) / (max - min)) * 100),
    [min, max]
  );

  // Update range bar position
  useEffect(() => {
    if (!range.current) return;

    const minPercent = getPercent(minVal);
    const maxPercent = getPercent(maxVal);

    range.current.style.left = `${minPercent}%`;
    range.current.style.width = `${maxPercent - minPercent}%`;

  }, [minVal, maxVal, getPercent]);

  // Called when user finishes sliding
  const handleFinalChange = () => {
    onChange({
      min: minVal,
      max: maxVal
    });
  };

  return (
    <div className="multiRangeSlider">

      {/* MIN slider */}
      <input
        type="range"
        min={min}
        max={max}
        value={minVal}
        ref={minValRef}
        onChange={(e) => {
          const value = Math.min(Number(e.target.value), maxVal - 1);
          setMinVal(value);
        }}

        onPointerUp={handleFinalChange}
        onMouseUp={handleFinalChange}
        onTouchEnd={handleFinalChange}

        className={classnames("thumb thumb--zindex-3", {
          "thumb--zindex-5": minVal > max - 100
        })}
      />

      {/* MAX slider */}
      <input
        type="range"
        min={min}
        max={max}
        value={maxVal}
        ref={maxValRef}
        onChange={(e) => {
          const value = Math.max(Number(e.target.value), minVal + 1);
          setMaxVal(value);
        }}

        onPointerUp={handleFinalChange}
        onMouseUp={handleFinalChange}
        onTouchEnd={handleFinalChange}

        className="thumb thumb--zindex-4"
      />

      {/* Slider track */}
      <div className="slider">

        <div className="slider__track" />

        <div
          ref={range}
          className="slider__range"
        />

        <div className="slider__left-value">
          ₹ {minVal}
        </div>

        <div className="slider__right-value">
          ₹ {maxVal}
        </div>

      </div>

    </div>
  );
};

MultiRangeSlider.propTypes = {

  min: PropTypes.number.isRequired,

  max: PropTypes.number.isRequired,

  onChange: PropTypes.func.isRequired

};

export default MultiRangeSlider;
